import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MessageService } from '@services';

@Component({
  selector: 'app-relatorio-contas-receber',
  templateUrl: './relatorio-contas-receber.component.html',
  styleUrls: ['./relatorio-contas-receber.component.css'],
})
export class RelatorioContasReceberComponent extends ModalCadastroComponent implements OnInit {
  constructor(private message: MessageService) {
    super();
  }

  @ViewChild('modalRelatorio', { static: true }) modalRelatorio;
  form: FormGroup;
  imprimirSub: Subscription;
  selecionados: [] = [];


  tiposAgrupamento = [
    { id: 0, label: 'Sem agrupamento' },
    { id: 1, label: 'Emissão' },
    { id: 2, label: 'Vencimento' },
    { id: 3, label: 'Pagamento' },
    { id: 4, label: 'Cliente' },
    { id: 5, label: 'Vendedor' },
  ];

  ngOnInit(): void {
    this.form = new FormGroup({
      tipoAgrupamento: new FormControl(0, [Validators.required]),
      formato: new FormControl(false),
      somenteDocumentosSelecionados: new FormControl(false),
    });

    this.selecionados = this.prop;
  }

  show(): void {
    this.modalRelatorio.show();
  }

  close() {
    this.closed.emit(null);
  }

  imprimir() {
    if (this.form.invalid) {
      return;
    }
    this.closed.emit(this.form.value);
  }

  checkSelecionados() {
    if (this.selecionados.length > 0) {
      return;
    }

    this.form.controls['somenteDocumentosSelecionados'].setValue(false);
    this.message.warning('Nenhum documento selecionado na consulta.', 8000, 'Aviso!');
  }
}
